<template lang="pug">
  #program-center
    router-view
</template>

<script>
export default {
  name: "ProgramCenter"
};
</script>

<style lang="sass" scoped></style>
